import React from 'react';

// Admin's WhatsApp number lives only here, inside the click handler —
// it's never printed as visible text anywhere on the page.
// Note: this keeps it off-screen for casual visitors, but since this is
// a client-side app, anyone who inspects the JavaScript source can still
// find it. There's no way to fully hide a number that the browser itself
// has to use to build the WhatsApp link.
const ADMIN_WHATSAPP = '254714644890'; // 0714 644 890 in international format

const WhatsAppAdminButton = () => {
  const openWhatsApp = () => {
    window.open(`https://wa.me/${ADMIN_WHATSAPP}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={openWhatsApp}
      className="brand-cta"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        width: '100%',
        background: '#25D366',
        color: '#0a0a0a',
        border: 'none',
        borderRadius: '4px',
        padding: '12px 20px',
        fontSize: '20px',
        cursor: 'pointer',
      }}
    >
      💬 Talk to Admin
    </button>
  );
};

export default WhatsAppAdminButton;
